module.exports = __webpack_public_path__ + "img/2-4.dfe60b0e.jpg";